import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { getNotificationSettingsPath } from "utils/router.utils";
import { getItemSession, saveItemSession } from "utils/session";

import CustomTabs from "components/Tab";
import TextWithRightArrow from "components/TextWithRightArrow";

import { InsightsStrings, RefreshKey, userProfileStrings } from "../../constants/constantStrings";

import ActiveInsights from "./ActiveInsights";
import InsightsHistory from "./InsightsHistory";
import InsightsList from "./InsightsList";

import "./index.scss";

const InsightTabs = props => {
  const location = useLocation();
  let refreshedTab = JSON.parse(getItemSession(RefreshKey.insightTabKey));
  refreshedTab = refreshedTab !== null ? refreshedTab : 1;
  const [value, setValue] = useState(refreshedTab);
  const [activeInsightCount, setActiveInsightCount] = useState("");
  const [insightsListCount, setInsightsListCount] = useState("");

  const insightsTabOption = [
    { tabval: InsightsStrings.activeInsights, page: <ActiveInsights setActiveInsightCount={setActiveInsightCount} />, count: activeInsightCount },
    { tabval: InsightsStrings.insightsHistory, page: <InsightsHistory /> },
    { tabval: InsightsStrings.insightsList, page: <InsightsList setInsightsListCount={setInsightsListCount} />, count: insightsListCount }
  ];
  const selectedPage = insightsTabOption[value].page;

  const onTabSelected = value => {
    saveItemSession(RefreshKey.insightTabKey, JSON.stringify(value));
    setValue(value);
    if (location?.state?.tab) {
      window.history.replaceState(null, "");
    }
  };

  useEffect(() => {
    setValue(refreshedTab);
  }, [refreshedTab]);

  return (
    <div className="insights-container">
      <div className="insights-flex">
        <CustomTabs tabOptions={insightsTabOption} tabChangeHandler={onTabSelected} value={value} />
        <Link to={getNotificationSettingsPath()}>
          <TextWithRightArrow text={userProfileStrings.notificationSetting} />
        </Link>
      </div>
      <div>{selectedPage}</div>
    </div>
  );
};
export default InsightTabs;
